<template>
  <!-- drawer department add -->
  <el-drawer
    :title="editorText + '机构'"
    :visible.sync="dialogVisible"
    custom-class="zyyj-dialog"
    direction="rtl"
    :show-close="false"
    @open="handleOpen"
  >
    <el-form label-width="120px" :rules="rules" ref="form" :model="form">
      <el-row>
        <el-col :span="24">
          <el-form-item label="机构名称" prop="name">
            <el-input v-model.trim="form.name" :maxlength="20" placeholder="请输入机构名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="信用代码" prop="credit">
            <el-input v-model.trim="form.credit" :maxlength="20" placeholder="请输入信用代码"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="行政级别" prop="level">
            <el-select placeholder="请选择" v-model="form.level" clearable :disabled="editing" @change="changeLevel">
              <el-option
                v-for="item in levels"
                :key="item.value"
                :label="item.name"
                :value="item.value"
                :disabled="item.value === 1 && identify.cityLevel && identify.cityLevel.length > 0"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属地区" prop="area">
            <el-select v-if="form.level === 1" placeholder="请选择" v-model="form.area">
              <el-option
                v-for="item in areas"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-cascader
              v-else-if="form.level === 2"
              expand-trigger="hover"
              :options="areas"
              :props="props"
              separator=" / "
              v-model="form.area"
              placeholder="请选择"
            ></el-cascader>
            <el-select v-else placeholder="请选择" v-model="form.area">
              <el-option
                v-for="item in []"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :disabled="submitting" @click="submitForm('form')">确 定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import _ from 'lodash'
import __ from '@/util/common-utils'
export default {
  props: ['identify', 'visible'],
  data () {
    var validateName = (rule, value, callback) => {
      if (value.replace(/[\u4e00-\u9fa5]/g, '').length !== 0) {
        callback(new Error('机构名称仅支持中文字符'))
      } else {
        callback()
      }
    }
    var validateCredit = (rule, value, callback) => {
      if (/^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/.test(value) === false) {
        callback(new Error('信用代码格式不正确'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [
          { required: true, message: '机构名称不得为空', trigger: 'blur' },
          { validator: validateName, trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        credit: [
          { required: true, message: '信用代码不得为空', trigger: 'blur' },
          { validator: validateCredit, trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请选择行政级别', trigger: ['blur', 'change'] }
        ],
        area: [
          { required: true, message: '请选择所属地区', trigger: ['blur', 'change'] }
        ]
      },
      props: {
        value: 'value',
        label: 'name',
        children: 'children'
      },
      departments: [],
      submitting: false,
      form: { id: null, name: '', credit: '', level: '', area: [] },
      levels: [
        {
          name: '市级',
          value: 1
        },
        {
          name: '区（县）级',
          value: 2
        }
      ],
      areas: [],
      isLastSuccessful: false
    }
  },
  computed: {
    dialogVisible: {
      get () { return this.visible === true },
      set () { this.$emit('update:visible', false) }
    },
    editing () { return this.identify && this.identify.id > 0 },
    editorText () { return this.identify && this.identify.id ? '编辑' : '添加' }
  },
  mounted () {

  },
  methods: {
    handleOpen () {
      this.$refs.form && this.$refs.form.resetFields()
      this.submitting = false
      this.form.name = this.identify.name || ''
      this.form.credit = this.identify.creditCode || ''
      this.form.level = this.identify.level || ''
      if (this.identify && this.identify.level === 1) {
        this.$xhrGet(`/acc/regions/city`).then(rs => {
          let rsArr = []
          rsArr.push(rs.data)
          this.areas = rsArr
          this.form.area = this.identify.region.value
        })
      } else if (this.identify && this.identify.level === 2) {
        this.$xhrGet(`/acc/regions/area`).then(rs => {
          let rsArr = []
          rs.data.name = rs.data.left
          rs.data.value = rs.data.middle
          rs.data.children = rs.data.right
          rsArr.push(rs.data)
          this.areas = rsArr
          let temp = []
          temp.push(rs.data.middle)
          temp.push(this.identify.region.value)
          this.form.area = temp
        })
      } else {
        this.form.area = null
      }
    },

    changeLevel (val) {
      if (val === 1) {
        this.$xhrGet(`/acc/regions/city`).then(rs => {
          let rsArr = []
          rsArr.push(rs.data)
          this.areas = rsArr
          this.form.area = ''
        })
      } else {
        this.$xhrGet(`/acc/regions/area`).then(rs => {
          let rsArr = []
          rs.data.name = rs.data.left
          rs.data.value = rs.data.middle
          rs.data.children = rs.data.right
          rsArr.push(rs.data)
          this.areas = rsArr
          this.form.area = []
        })
      }
    },

    closeDialog () {
      if (this.isLastSuccessful) {
        this.$emit('edit-result', true)
      }
      this.$emit('update:visible', false)
    },

    xhrUpdate () {
      let region = null
      if (this.form.level === 1) {
        region = this.identify.region.value
      } else if (this.form.level === 2) {
        let arr = []
        arr.push(this.areas[0].value)
        arr.push(this.identify.region.value)
        region = arr
      }
      let realFormData = {
        name: this.form.name === this.identify.name ? null : this.form.name,
        creditCode: this.form.credit === this.identify.creditCode ? null : this.form.credit,
        level: this.form.level === this.identify.level ? null : this.form.level,
        regionId: _.isEqual(this.form.area, region) ? null : (Array.isArray(this.form.area) ? this.form.area[1] : this.form.area)
      }
      if (__.isObjectPropertiesAllNull(realFormData)) {
        this.submitting = false
        this.$message.error('请修改信息后提交')
        return
      }
      this.$xhrPut(`/acc/institutions/${this.identify.id}`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'name_exists') {
            this.$message.error('机构名称已存在')
          } else if (rs.code === 'creditCode_exists') {
            this.$message.error('信用代码已存在')
          } else if (rs.code === 'PARAM_ERROR') {
            this.$message.error('请检查输入')
          }
        }
      })
    },

    xhrAdd () {
      let realFormData = {
        name: this.form.name,
        creditCode: this.form.credit,
        level: this.form.level,
        regionId: Array.isArray(this.form.area) ? this.form.area[1] : this.form.area
      }
      this.$xhrPost(`/acc/institutions`, realFormData).then(rs => {
        if (!rs) {
          this.submitting = false
        }
        if (rs.code === 'SUCCESS') {
          this.isLastSuccessful = true
          this.closeDialog()
        } else {
          this.submitting = false
          if (rs.code === 'name_exists') {
            this.$message.error('机构名称已存在')
          } else if (rs.code === 'duplicate_creditCode') {
            this.$message.error('信用代码已存在')
          } else if (rs.code === 'PARAM_ERROR') {
            this.$message.error('请检查输入')
          } else if (rs.code === 'bad_request') {
            this.$message.error('只允许添加一个市级机构')
          }
        }
      })
    },

    submitForm (formName) {
      this.submitting = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editing ? this.xhrUpdate() : this.xhrAdd()
        } else {
          this.submitting = false
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/operate/DepartmentEditor.vue